/* eslint-disable prefer-const */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { apiState, apiInstance, getStateByStatus, ApiStates, ApiError } from '../../Api'
import {
  Projeto,
  Professor,
  UpdateAdvisorRequest,
  RelatorioParcial,
  RelatorioParcialCoordenador,
  AvaliacaoOD,
  ProjetoComOficinaDeDebate,
  Evento,
  AvaliacaoEJC,
  ProjetoComEncontroJuridico,
  RelatorioFinalCoordenador,
  RelatorioFinal,
  AvaliacaoRelatorioFinal,
  ParametroProjeto
} from '../../Domain/Shared'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { AssignEvaluatorsRequest } from '../../Domain/Shared/AssignEvaluatorsRequest'
import { Orientacao } from '../../Domain/Shared/Orientacao'

interface SharedState {
  avaliacaoRelatorioFinal?: any | null | undefined
  anexosRelatorioFinal?: any | null | undefined
  relatoriosFinais?: RelatorioFinal[] | null | undefined
  relatoriosParciais?: RelatorioParcial[] | null | undefined
  orientacoes?: Orientacao[] | null | undefined
  relatoriosParciaisCoordenador?: RelatorioParcialCoordenador[] | null | undefined
  projetos?: Projeto[] | null | undefined
  projetosOficinasDebate?: ProjetoComOficinaDeDebate[] | null | undefined
  projetosEncontrosJuridicos?: ProjetoComEncontroJuridico[] | null | undefined
  professores?: Professor[] | null
  professorAvaliacoes?: Professor[] | null
  professoresAtivos?: Professor[] | null
  projeto?: Projeto | null
  avaliacaoOficinaDebate?: AvaliacaoOD[] | null
  avaliacaoEncontroJuridico?: AvaliacaoEJC[] | null
  apiStates: ApiStates<typeof customActions>
  evento?: Evento[] | null | undefined
  parametroProjeto?: ParametroProjeto[]
  parametroProjetoList?: ParametroProjeto[]
}

let initialState: SharedState = {
  apiStates: {},
}

const sharedSlice = createSlice({
  name: 'sharedSlice',
  initialState,
  reducers: {
    setApiState: (state, action: PayloadAction<ApiStates<typeof customActions>>) => {
      state.apiStates = { ...state.apiStates, ...action.payload }
    },
    setProjetos: (state, action: PayloadAction<Projeto[]>) => {
      state.projetos = action.payload
    },
    setProjetosOficinasDebate: (state, action: PayloadAction<ProjetoComOficinaDeDebate[]>) => {
      state.projetosOficinasDebate = action.payload
    },
    setProjetosEncontrosJuridicos: (state, action: PayloadAction<ProjetoComEncontroJuridico[]>) => {
      state.projetosEncontrosJuridicos = action.payload
    },
    setProjeto: (state, action: PayloadAction<Projeto>) => {
      state.projeto = action.payload
    },
    setProfessores: (state, action: PayloadAction<Professor[]>) => {
      state.professores = action.payload
    },
    setProfessorAvaliacoes: (state, action: PayloadAction<Professor[]>) => {
      state.professorAvaliacoes = action.payload
    },
    setProfessoresAtivos: (state, action: PayloadAction<Professor[]>) => {
      state.professoresAtivos = action.payload
    },
    setRelatoriosParciais: (state, action: PayloadAction<RelatorioParcial[]>) => {
      state.relatoriosParciais = action.payload
    },
    setOrientacoes: (state, action: PayloadAction<Orientacao[]>) => {
      state.orientacoes = action.payload
    },
    setRelatoriosParciaisCoordenador: (state, action: PayloadAction<RelatorioParcialCoordenador[]>) => {
      state.relatoriosParciaisCoordenador = action.payload
    },
    setAvaliacaoOficinaDebate: (state, action: PayloadAction<AvaliacaoOD[]>) => {
      state.avaliacaoOficinaDebate = action.payload
    },
    setAvaliacaoEncontroJuridico: (state, action: PayloadAction<AvaliacaoEJC[]>) => {
      state.avaliacaoEncontroJuridico = action.payload
    },
    setEvento: (state, action: PayloadAction<Evento[]>) => {
      state.evento = action.payload
    },
    setRelatoriosFinais: (state, action: PayloadAction<RelatorioFinal[]>) => {
      state.relatoriosFinais = action.payload
    },
    setAnexosRelatorioFinal: (state, action: PayloadAction<any>) => {
      state.anexosRelatorioFinal = action.payload
    },
    setAvaliacaoRelatorioFinal: (state, action: PayloadAction<AvaliacaoRelatorioFinal[]>) => {
      state.avaliacaoRelatorioFinal = action.payload
    },
    setParametroProjeto: (state, action: PayloadAction<ParametroProjeto[]>) => {
      state.parametroProjeto = action.payload
    },
    setParametroProjetoList: (state, action: PayloadAction<ParametroProjeto[]>) => {
      state.parametroProjetoList = action.payload
    },
  },
})

const customActions = { 
  avaliacoesRelatoriosFinaisAction: (perfil: any) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ avaliacoesRelatoriosFinaisAction: { state: apiState.loading } }))
        let result

        result = await apiInstance.get<AvaliacaoRelatorioFinal[]>(`${perfil}/relatoriofinal/avaliacoes`)

        dispatch(sharedSlice.actions.setAvaliacaoRelatorioFinal(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ avaliacoesRelatoriosFinaisAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ avaliacoesRelatoriosFinaisAction: { state: apiState.error, error: error } }))
      }
    }
  },
 encontroJuridicoAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ encontroJuridicoAction: { state: apiState.loading } }))
        let result

        result = await apiInstance.get<AvaliacaoEJC[]>(`${perfil}/encontrojuridicocientifico`)

        dispatch(sharedSlice.actions.setAvaliacaoEncontroJuridico(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ encontroJuridicoAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ encontroJuridicoAction: { state: apiState.error, error: error } }))
      }
    }
  },

  eventoAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ eventoAction: { state: apiState.loading } }))

        const result = await apiInstance.get<Evento[]>('eventos')

        dispatch(sharedSlice.actions.setEvento(result.data))

        dispatch(sharedSlice.actions.setApiState({ eventoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ eventoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  oficinaDebateAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ oficinaDebateAction: { state: apiState.loading } }))
        let result

          result = await apiInstance.get<AvaliacaoOD[]>(`${perfil}/oficinasdedebates`)

        dispatch(sharedSlice.actions.setAvaliacaoOficinaDebate(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ oficinaDebateAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ oficinaDebateAction: { state: apiState.error, error: error } }))
      }
    }
  },
  professorAvaliarEncontroJuridicoAction: (avaliacao?: any, id?: any) => {
    let info = {
      ProjetoId: id,
      professorReferencias: avaliacao.professorReferencias,
      professorReferenciasNota: avaliacao.professorReferenciasNota,
      professorResultado: avaliacao.professorResultado,
      professorResultadoNota: avaliacao.professorResultadoNota,
      professorTema: avaliacao.professorTema,
      professorTemaNota: avaliacao.professorTemaNota,
    }
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({professorAvaliarEncontroJuridicoAction: { state: apiState.loading } })
        )
        const result = await apiInstance.post('orientador/encontrojuridicocientifico', info)
        dispatch(
          sharedSlice.actions.setApiState({
          professorAvaliarEncontroJuridicoAction: { state: getStateByStatus(result.status) },
          })
        )
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({
          professorAvaliarEncontroJuridicoAction: { state: apiState.error, error: error },
          })
        )
        console.log(error)
      }
    }
  },
  professorAvaliarOficinaDebateAction: (avaliacao?: any, id?: any) => {
    let info = {
      ProjetoId: id,
      professorReferencias: avaliacao.professorReferencias,
      professorReferenciasNota: avaliacao.professorReferenciasNota,
      professorInvestigacao: avaliacao.professorInvestigacao,
      professorInvestigacaoNota: avaliacao.professorInvestigacaoNota,
      professorAdequacao: avaliacao.professorAdequacao,
      professorAdequacaoNota: avaliacao.professorAdequacaoNota,
      professorRecomendacoes: avaliacao.professorRecomendacoes,
    }
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({professorAvaliarOficinaDebateAction: { state: apiState.loading } })
        )
        const result = await apiInstance.post('orientador/oficinasdedebates', info)
        dispatch(
          sharedSlice.actions.setApiState({
          professorAvaliarOficinaDebateAction: { state: getStateByStatus(result.status) },
          })
        )
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({
          professorAvaliarOficinaDebateAction: { state: apiState.error, error: error },
          })
        )
        console.log(error)
      }
    }
  },
  professorAvaliarRelatorioFinalAction: (avaliacao?: RelatorioFinalCoordenador, id?: any) => {
    let info = {
      relatorioFinalId: id,
      tituloClareza: avaliacao?.tituloClareza,
      tituloNota: avaliacao?.tituloNota,
      resumoMetodologiaSintese: avaliacao?.resumoMetodologiaSintese,
      resumoClareza: avaliacao?.resumoClareza,
      resumoPalavrasChave: avaliacao?.resumoPalavrasChave,
      resumoNota: avaliacao?.resumoNota,
      introducaoObjetivos: avaliacao?.introducaoObjetivos,
      introducaoProblemaDeEstudo: avaliacao?.introducaoProblemaDeEstudo,
      introducaoMetodologia: avaliacao?.introducaoMetodologia,
      introducaoHipoteses: avaliacao?.introducaoHipoteses,
      introducaoHipotesesPertinencia: avaliacao?.introducaoHipotesesPertinencia,
      introducaoNota: avaliacao?.introducaoNota,
      desenvolvimentoExposicao: avaliacao?.desenvolvimentoExposicao,
      desenvolvimentoDivisaoInterna: avaliacao?.desenvolvimentoDivisaoInterna,
      desenvolvimentoConceitosOperacionais: avaliacao?.desenvolvimentoConceitosOperacionais,
      desenvolvimentoFundamentacaoTeorica: avaliacao?.desenvolvimentoFundamentacaoTeorica,
      desenvolvimentoNota: avaliacao?.desenvolvimentoNota,
      consideracoesFinaisObjetividade: avaliacao?.consideracoesFinaisObjetividade,
      consideracoesFinaisContribuicoes: avaliacao?.consideracoesFinaisContribuicoes,
      consideracoesFinaisConsequenciaLogica: avaliacao?.consideracoesFinaisConsequenciaLogica,
      consideracoesFinaisRelevancia: avaliacao?.consideracoesFinaisRelevancia,
      consideracoesFinaisNota: avaliacao?.consideracoesFinaisNota,
      referenciasPertinencia: avaliacao?.referenciasPertinencia,
      referenciasNota: avaliacao?.referenciasNota,
      Parecer: avaliacao?.parecer,
    }
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({ professorAvaliarRelatorioFinalAction: { state: apiState.loading } })
        )
        const result = await apiInstance.post('relatoriofinal', info)
        dispatch(
          sharedSlice.actions.setApiState({
            professorAvaliarRelatorioFinalAction: { state: getStateByStatus(result.status) },
          })
        )
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({
            professorAvaliarRelatorioFinalAction: { state: apiState.error, error: error },
          })
        )
        console.log(error)
      }
    }
  },
  professorAvaliarRelatorioParcialAction: (avaliacao?: any, id?: any) => {
    let info = {
      idDoRelatorioParcial: id,
      professorReferencias: avaliacao.professorReferencias,
      professorReferenciasNota: avaliacao.professorReferenciasNota,
      professorInvestigacao: avaliacao.professorInvestigacao,
      professorInvestigacaoNota: avaliacao.professorInvestigacaoNota,
      professorAdequacao: avaliacao.professorAdequacao,
      professorAdequacaoNota: avaliacao.professorAdequacaoNota,
      professorEstadoDaArte: avaliacao.professorEstadoDaArte,
      professorEstadoDaArteNota: avaliacao.professorEstadoDaArteNota,
      professorRecomendacoes: avaliacao.professorRecomendacoes,
    }
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({ professorAvaliarRelatorioParcialAction: { state: apiState.loading } })
        )
        const result = await apiInstance.post('orientador/relatorioparcial', info)
        dispatch(
          sharedSlice.actions.setApiState({
            professorAvaliarRelatorioParcialAction: { state: getStateByStatus(result.status) },
          })
        )
        window.location.reload()
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({
            professorAvaliarRelatorioParcialAction: { state: apiState.error, error: error },
          })
        )
        console.log(error)
      }
    }
  },
  relatoriosFinaisAction: (perfil: any) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ relatoriosFinaisAction: { state: apiState.loading } }))
        let result

          result = await apiInstance.get<RelatorioFinal[]>(`${perfil}/relatoriofinal`)
        

        dispatch(sharedSlice.actions.setRelatoriosFinais(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ relatoriosFinaisAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ relatoriosFinaisAction: { state: apiState.error, error: error } }))
      }
    }
  },
  anexosRelatorioFinalAction: (perfil: string, id: any) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ anexosRelatorioFinalAction: { state: apiState.loading } }))
        let result

          result = await apiInstance.get<any>(`${perfil}/relatoriofinal/anexos/${id}`)

        dispatch(sharedSlice.actions.setAnexosRelatorioFinal(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ anexosRelatorioFinalAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ anexosRelatorioFinalAction: { state: apiState.error, error: error } }))
      }
    }
  },
  relatoriosParciaisAction: (perfil: any) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ relatoriosParciaisAction: { state: apiState.loading } }))
        let result

        if (perfil == 'orientador') {
          result = await apiInstance.get<RelatorioParcial[]>('orientador/relatorioparcial/avaliador')
        } else if (perfil == 'coordenadoric') {
          result = await apiInstance.get<RelatorioParcial[]>('coordenadoric/relatorioparcial')
        } else {
          result = await apiInstance.get<RelatorioParcial[]>('funcionario/relatorioparcial')
        }

        dispatch(sharedSlice.actions.setRelatoriosParciais(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ relatoriosParciaisAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ relatoriosParciaisAction: { state: apiState.error, error: error } }))
      }
    }
  },
  orientacoesAction: (perfil: any) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ orientacoesAction: { state: apiState.loading } }))
        let result

        result = await apiInstance.get<Orientacao[]>('orientador/orientacao')

        dispatch(sharedSlice.actions.setOrientacoes(result.data))

        dispatch(
          sharedSlice.actions.setApiState({ orientacoesAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ orientacoesAction: { state: apiState.error, error: error } }))
      }
    }
  },
  editarRelatorioParcialAction: (relatorioParcial: RelatorioParcial) => {
    const info = {
      relatorioParcialId: relatorioParcial.id,
      alunoInvestigacao: relatorioParcial.alunoInvestigacao,
      alunoObjetivo: relatorioParcial.alunoObjetivo,
      alunoReferencias: relatorioParcial.alunoReferencias,
      alunoSolucao: relatorioParcial.alunoSolucao,
    }
    
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.post('orientador/relatorioparcial/editar/', info)

        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: getStateByStatus(result.status) } }))
        window.location.reload()
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  editarRelatorioFinalAction: (relatorioFinal: RelatorioFinal, anexo?: string) => {
    const info = {
      relatorioFinalId: relatorioFinal.id,
      titulo: relatorioFinal.titulo,
      sumario: relatorioFinal.sumario,
      resumo: relatorioFinal.resumo,
      palavrasChave: relatorioFinal.palavrasChave,
      introducao: relatorioFinal.introducao,
      desenvolvimento: relatorioFinal.desenvolvimento,
      conclusao: relatorioFinal.conclusao,
      referencias: relatorioFinal.referencias,
      anexo: anexo
    }
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.post('orientador/relatoriofinal/editar/', info)

        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: getStateByStatus(result.status) } }))
        window.location.reload()
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  aprovarProjetoAction: (id: string, parecer?: any, perfil?: string) => {
    const info = {
      //
      id,
      observacaoCoordenadorIC: '',
      observacaoProfessor: parecer,
      observacaoCoordenadorNP: parecer,
      //
      conceito: parecer.conceito,
      meritoCientific: parecer.meritoCientific,
      projetoTematico: parecer.projetoTematico,
      meritoCienProfe: parecer.meritoCienProfe,
      meritoAcadAluno: parecer.meritoAcadAluno,
      viabilidadeProjeto: parecer.viabilidadeProjeto,
      vinculacaoProjetoTematico: parecer.vinculacaoProjetoTematico,
    }
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ aprovarProjetoAction: { state: apiState.loading } }))
        if (perfil === undefined) throw 'Erro: "perfil não encontrado'
        const result = await apiInstance.post(`${perfil}/projeto/aprovar/`, info)

        if (result.status === 200) {
          toast.success('Projeto aprovado')
        }

        dispatch(sharedSlice.actions.setApiState({ aprovarProjetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ aprovarProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  editarProjetoAction: (projeto: Projeto) => {
    const info = {
      projetoId: projeto.id,
      tituloProjeto: projeto.tituloProjeto,
      objetivos: projeto.objetivos,
      objetivosGerais: projeto.objetivosGerais,
      objetivosEspecificos: projeto.objetivosEspecificos,
      contextualizacao: projeto.contextualizazao,
      delimitacaoTema: projeto.delimitacaoTema,
      problematizacao: projeto.problematizacao,
      referenciaBibliografia: projeto.referenciaBibliografia,
      metodo: projeto.metodo,
      justificativa: projeto.justificativa,
      cronogramaDescricao: projeto.cronogramaDescricao,
    }
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: apiState.loading } }))
        //if (perfil === undefined) throw 'Erro: "perfil não encontrado'
        const result = await apiInstance.post('orientador/projeto/editar/', info)

        if (result.status === 200) {
          toast.success('Projeto editado')
        }

        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ editarProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  reprovarProjetoAction: (id: string, parecer?: any, perfil?: string) => {
    const info = {
      id,
      observacaoCoordenadorIC: parecer,
      observacaoProfessor: parecer,
      observacaoCoordenadorNP: parecer,
      //
      conceito: parecer.conceito,
      meritoCientific: parecer.meritoCientific,
      projetoTematico: parecer.projetoTematico,
      meritoCienProfe: parecer.meritoCienProfe,
      meritoAcadAluno: parecer.meritoAcadAluno,
      viabilidadeProjeto: parecer.viabilidadeProjeto,
      vinculacaoProjetoTematico: parecer.vinculacaoProjetoTematico,
    }
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ reprovarProjetoAction: { state: apiState.loading } }))
        if (perfil === undefined) throw 'Erro: "perfil não encontrado'
        const result = await apiInstance.post(`${perfil}/projeto/reprovar/`, info)

        if (result.status === 200) {
          toast.error('Projeto reprovado')
        }

        dispatch(sharedSlice.actions.setApiState({ reprovarProjetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ reprovarProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  alterarProfessorProjetoAction: (perfil: string | undefined, data: UpdateAdvisorRequest) => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ alterarProfessorProjetoAction: { state: apiState.loading } }))
        const result = await apiInstance.post(`${perfil}/projeto/alterar/`, data)

        if (result.status === 200) {
          toast.success('Professor alterado')
        }
        dispatch(
          sharedSlice.actions.setApiState({ alterarProfessorProjetoAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({ alterarProfessorProjetoAction: { state: apiState.error, error: error } })
        )
      }
    }
  },
  cadastrarParametroProjetoAction: (
    parametroProjeto: ParametroProjeto,
    dataDeInicioRP?: string, dataDeFimRP?: string,
    dataDeInicioRF?: string, dataDeFimRF?: string,
    dataDeInicioEJC?: string, dataDeFimEJC?: string,
    dataDeInicioOD?: string, dataDeFimOD?: string, id?: Number,) => {
    const body = {
      id: id,
      processo: parametroProjeto.processo,
      serie: parametroProjeto.serie,
      dataDeInicio: new Date(parametroProjeto.dataDeInicio+':00.000Z'),
      dataDeFim: new Date(parametroProjeto.dataDeFim+':00.000Z'),
      dataDeInicioInscricoes: new Date(parametroProjeto.dataDeInicioInscricoes+':00.000Z'),
      dataDeFimInscricoes: new Date(parametroProjeto.dataDeFimInscricoes+':00.000Z'),
      dataDeFimInscricoesOrientador: new Date(parametroProjeto.dataDeFimInscricoesOrientador+':00.000Z'),
      dataDeInicioRP: new Date(dataDeInicioRP+':00.000Z'),
      dataDeFimRP: new Date(dataDeFimRP+':00.000Z'),
      dataDeInicioRF: new Date(dataDeInicioRF+':00.000Z'),
      dataDeFimRF: new Date(dataDeFimRF+':00.000Z'),
      dataDeInicioEJC: new Date(dataDeInicioEJC+':00.000Z'),
      dataDeFimEJC: new Date(dataDeFimEJC+':00.000Z'),
      dataDeInicioOD: new Date(dataDeInicioOD+':00.000Z'),
      dataDeFimOD: new Date(dataDeFimOD+':00.000Z'),
      observacao: parametroProjeto.observacao
    }
    
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ cadastrarParametroProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.post('projeto/parametroprojeto', body)

        if (result.status === 200) {
          toast.success('Parâmetro salvo/inserido com sucesso!')
        }

        dispatch(
          sharedSlice.actions.setApiState({ cadastrarParametroProjetoAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({ cadastrarParametroProjetoAction: { state: apiState.error, error: error } })
        )
      }
    }
  },
  cadastrarOrientacaoAction: (
    dataDeInicio?: string, dataDeFim?: string, resumo?: string, projetoId?: Number) => {
    const body = {
      resumo,
      dataDeInicio: new Date(dataDeInicio+':00.000Z'),
      dataDeFim: new Date(dataDeFim+':00.000Z'),
      projetoId,
    }
    
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ cadastrarOrientacaoAction: { state: apiState.loading } }))

        const result = await apiInstance.post('orientador/orientacao', body)

        dispatch(
          sharedSlice.actions.setApiState({ cadastrarOrientacaoAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(
          sharedSlice.actions.setApiState({ cadastrarOrientacaoAction: { state: apiState.error, error: error } })
        )
      }
    }
  },
  parametroProjetoAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ parametroProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.get<ParametroProjeto[]>('projeto')

        dispatch(sharedSlice.actions.setParametroProjeto(result.data))

        dispatch(sharedSlice.actions.setApiState({ parametroProjetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ parametroProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  parametroProjetoListAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(sharedSlice.actions.setApiState({ parametroProjetoListAction: { state: apiState.loading } }))

        const result = await apiInstance.get<ParametroProjeto[]>('projeto/parametroprojeto')

        dispatch(sharedSlice.actions.setParametroProjetoList(result.data))

        dispatch(sharedSlice.actions.setApiState({ parametroProjetoListAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(sharedSlice.actions.setApiState({ parametroProjetoListAction: { state: apiState.error, error: error } }))
      }
    }
  },
  updateProjetosAction: (perfil: string | undefined, professorId?: string) => {
    let result
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosAction: {
              state: apiState.loading,
            },
          })
        )

        if (perfil === undefined) throw 'Erro: "perfil não encontrado'

        if (perfil === 'orientador') {
          result = await apiInstance.get<Projeto[]>(`${perfil}/projeto/`)
        } else if (perfil === 'aluno') {
          result = await apiInstance.get<Projeto[]>(`${perfil}/projeto/`)
        } else {
          result = await apiInstance.get<Projeto[]>(`${perfil}/professor/projetos/${professorId}`)
        }

        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProjetos(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
  updateProjetosOficinaDebateAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosOficinaDebateAction: {
              state: apiState.loading,
            },
          })
        )
        const result = await apiInstance.get<ProjetoComOficinaDeDebate[]>(`${perfil}/projeto/oficinasdedebates`)
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosOficinaDebateAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProjetosOficinasDebate(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosOficinaDebateAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
  updateProjetosEncontroJuridicoAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosEncontroJuridicoAction: {
              state: apiState.loading,
            },
          })
        )
        const result = await apiInstance.get<ProjetoComEncontroJuridico[]>(`${perfil}/projeto/encontrojuridicocientifico`)
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosEncontroJuridicoAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProjetosEncontrosJuridicos(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosEncontroJuridicoAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
  updateProjetoAction: (projetoId: string, perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetoAction: {
              state: apiState.loading,
            },
          })
        )
        if (perfil === undefined) throw 'Erro: "perfil não encontrado'
        if (projetoId === undefined) throw 'Erro: "professorId não encontrado'
        const result = await apiInstance.get<Projeto>(`${perfil}/projeto/${projetoId}`)
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetoAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProjeto(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProjetosAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
  professoreAvalicaoesAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            professoreAvalicaoesAction: {
              state: apiState.loading,
            },
          })
        )

        const result = await apiInstance.get<Professor[]>(`${perfil}/professor/avaliacoes`)

        dispatch(
          sharedSlice.actions.setApiState({
            professoreAvalicaoesAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProfessorAvaliacoes(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            professoreAvalicaoesAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },

  professoresAtivosAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            professoresAtivosAction: {
              state: apiState.loading,
            },
          })
        )

        const result = await apiInstance.get<Professor[]>(`${perfil}/professor/ativos`)

        dispatch(
          sharedSlice.actions.setApiState({
            professoresAtivosAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProfessoresAtivos(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            professoresAtivosAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },

  updateProfessoresAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProfessoresAction: {
              state: apiState.loading,
            },
          })
        )
        if (perfil === undefined) throw 'Erro: "perfil não encontrado'
        const result = await apiInstance.get<Professor[]>(`${perfil}/professor/`)

        dispatch(
          sharedSlice.actions.setApiState({
            updateProfessoresAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setProfessores(result.data))
      } catch (e) {
        dispatch(
          sharedSlice.actions.setApiState({
            updateProfessoresAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },

  atribuirAvaliadoresAction: (perfil: string | undefined, data: AssignEvaluatorsRequest) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            atribuirAvaliadoresAction: {
              state: apiState.loading,
            },
          })
        )

        const result = await apiInstance.post(`${perfil}/relatorioparcial`, data)

        if (result.status === 200) {
          toast.success('Avaliadores altribuidos')
        }

        dispatch(
          sharedSlice.actions.setApiState({
            atribuirAvaliadoresAction: {
              state: getStateByStatus(result.status),
            },
          })
        )
      } catch (e) {
        toast.error('Avaliadores não altribuidos')
        console.log(e)
        dispatch(
          sharedSlice.actions.setApiState({
            atribuirAvaliadoresAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
  atribuirAvaliadoresRelatorioFinalAction: (perfil: string, idProfessores?: any, relatorioFinalId?: any) => {
    const data = {
      relatorioFinalId: relatorioFinalId,
      professoresId: idProfessores
    } 
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            atribuirAvaliadoresRelatorioFinalAction: {
              state: apiState.loading,
            },
          })
        )

        const result = await apiInstance.post(`${perfil}/relatoriofinal/atribuir`, data)

        if (result.status === 200) {
          toast.success('Avaliadores altribuidos')
        }

        dispatch(
          sharedSlice.actions.setApiState({
            atribuirAvaliadoresRelatorioFinalAction: {
              state: getStateByStatus(result.status),
            },
          })
        )
      } catch (e) {
        toast.error('Avaliadores não altribuidos')
        console.log(e)
        dispatch(
          sharedSlice.actions.setApiState({
            atribuirAvaliadoresRelatorioFinalAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
  listaRelatoriosParciaisAction: (perfil: string) => {
    return async (dispatch: any) => {
      try {
        dispatch(
          sharedSlice.actions.setApiState({
            listaRelatoriosParciaisAction: {
              state: apiState.loading,
            },
          })
        )

        const result = await apiInstance.get<RelatorioParcialCoordenador[]>(`${perfil}/relatorioparcial/'`)

        dispatch(
          sharedSlice.actions.setApiState({
            listaRelatoriosParciaisAction: {
              state: getStateByStatus(result.status),
            },
          })
        )

        dispatch(sharedSlice.actions.setRelatoriosParciaisCoordenador(result.data))
      } catch (e) {
        console.log(e)
        dispatch(
          sharedSlice.actions.setApiState({
            listaRelatoriosParciaisAction: {
              state: getStateByStatus((e as AxiosError).response?.status || 500),
              error: e as AxiosError<ApiError>,
            },
          })
        )
      }
    }
  },
}

const SharedReducer = sharedSlice.reducer
const SharedActions = { ...customActions }

export { SharedReducer, SharedActions }
